// src/platform/deviceId.js
// Fair play (backend fairplay.py): a random device ID kept in localStorage and the nm_did cookie, sent as
// X-Device-Id on API calls (App.js wraps fetch/axios), so two accounts used from one device can be linked.
const KEY = 'nm_did';

function uuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  const b = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(b);
  else for (let i = 0; i < 16; i += 1) b[i] = Math.floor(Math.random() * 256);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

function readCookie() {
  const m = (typeof document !== 'undefined' ? document.cookie : '').match(/(?:^|;\s*)nm_did=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

let cached = null;
export function deviceId() {
  if (cached) return cached;
  let id = null;
  try { id = localStorage.getItem(KEY); } catch { /* private mode */ }
  id = id || readCookie() || uuid();
  try { localStorage.setItem(KEY, id); } catch { /* private mode */ }
  try { document.cookie = `nm_did=${encodeURIComponent(id)}; path=/; max-age=31536000; SameSite=Lax`; } catch { /* ignore */ }
  cached = id;
  return id;
}

// fetch(input, init) arguments with X-Device-Id added for calls to our API.
export function withDeviceHeader(input, init) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  if (!/\/api\//.test(url)) return [input, init];
  const headers = new Headers((init && init.headers) || (typeof input !== 'string' && input ? input.headers : undefined));
  if (!headers.has('X-Device-Id')) headers.set('X-Device-Id', deviceId());
  return [input, { ...(init || {}), headers }];
}
